var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"el-fade-in-linear"}},[(_vm.isRouterAlive)?_c('router-view'):_vm._e()],1),_c('el-backtop',{staticClass:"scrolldIV"}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }